/**
 * Cookie- en analytics-toestemming (AVG/ePrivacy).
 * Zie /cookies en Privacybeleid.
 */

export const COOKIE_CONSENT_STORAGE_KEY = 'calqtool_cookie_consent_v1';

export type ConsentStatus = 'unknown' | 'necessary_only' | 'analytics';

export interface StoredCookieConsent {
  analytics: boolean;
  updatedAt: string;
}

export function readStoredCookieConsent(): StoredCookieConsent | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const j = JSON.parse(raw) as { analytics?: boolean; updatedAt?: string };
    if (typeof j.analytics !== 'boolean') return null;
    return {
      analytics: j.analytics,
      updatedAt: typeof j.updatedAt === 'string' ? j.updatedAt : new Date().toISOString(),
    };
  } catch {
    return null;
  }
}

export function writeCookieConsent(acceptAnalytics: boolean): void {
  if (typeof window === 'undefined') return;
  const payload: StoredCookieConsent = {
    analytics: acceptAnalytics,
    updatedAt: new Date().toISOString(),
  };
  localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(payload));
}

export function clearCookieConsent(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(COOKIE_CONSENT_STORAGE_KEY);
}

export function readConsentStatus(): ConsentStatus {
  const s = readStoredCookieConsent();
  if (!s) return 'unknown';
  return s.analytics ? 'analytics' : 'necessary_only';
}

/** `true` alleen als gebruiker expliciet analytics heeft geaccepteerd. */
export function hasAnalyticsConsent(): boolean {
  return readConsentStatus() === 'analytics';
}
